const PasswordValidator = (passwordValue: string): IPasswordValidatorResult => {
    const conditions = checkEachCondition(passwordValue);

    let anyError = null;
    conditions.forEach((condition) => {
        if (condition.passed === false) {
            return (anyError = true);
        }
    });

    if (anyError) {
        const errorMessage = generateErrorMessage(conditions);
        return { passed: false, error: errorMessage, conditions: conditions };
    } else {
        return { passed: true, conditions: conditions };
    }
};

function checkEachCondition(passwordValue: string): Condition[] {
    const lowerCaseLetters = /[a-z]/g;
    const upperCaseLetters = /[A-Z]/g;
    const specialCharacters = /[£!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/g;
    const numbers = /[0-9]/g;

    const conditions = [];

    function createCondition(name: string, passed: boolean) {
        return { name: name, passed: passed } as Condition;
    }

    const lowercaseLettersCheck = Boolean(passwordValue.match(lowerCaseLetters));
    conditions.push(createCondition("Please use at least one lowercase letter", lowercaseLettersCheck));

    const uppercaseLettersCheck = Boolean(passwordValue.match(upperCaseLetters));
    conditions.push(createCondition("Please use at least one uppercase letter", uppercaseLettersCheck));

    const specialCharactersCheck = Boolean(passwordValue.match(specialCharacters));
    conditions.push(createCondition("Please use at least one symbol", specialCharactersCheck));

    const numbersCheck = Boolean(passwordValue.match(numbers));
    conditions.push(createCondition("Please use at least one number", numbersCheck));

    const minPasswordLengthCheck = passwordValue.length >= 8;
    conditions.push(createCondition("Please use at least 8 characters", minPasswordLengthCheck));

    return conditions;
}

function generateErrorMessage(conditions: Condition[]): string {
    let errorMessage = "";

    conditions.forEach((condition) => {
        if (condition.passed === false) {
            errorMessage += `${condition.name}. `;
        }
    });

    return errorMessage;
}

interface IPasswordValidatorResult {
    conditions?: Condition[];
    passed?: boolean;
    error?: string;
}

interface Condition {
    name: string;
    passed: boolean;
}

export default PasswordValidator;
export type { IPasswordValidatorResult, Condition };
